import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMacroECDates, getSeasonalityData } from "layouts/applications/data-tables/data/getData";

const initialState = {
  ecDates: [],
  seasonalityData: null,
  driversRisksData: null
};

export const loadECDates = createAsyncThunk("macro/ecdates", async () => {
  const ecDates = await getMacroECDates();
  return ecDates;
});

export const loadSeasonalityData = createAsyncThunk("macro/seasonality", async () => {
  const seasonalityData = await getSeasonalityData();
  return seasonalityData;
});

export const etcSlice = createSlice({
  name: "etc",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      if (!key) return;

      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadECDates.fulfilled, (state, action) => {
      if (!action.payload) return;

      state.ecDates = action.payload;
    });

    builder.addCase(loadSeasonalityData.fulfilled, (state, action) => {
      if (!action.payload) return;

      state.seasonalityData = action.payload;
    });
  },
});

export const { setKeyValue } = etcSlice.actions;

export default etcSlice.reducer;
